var _defs, _path, _mask;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon_trash_svg__a",
    d: "M0 32h32V0H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M18 5V2h-4v3H4v2h24V5zM24 28H8V9H6v20a1 1 0 001 1h18a1 1 0 001-1V9h-2v19z"
  }), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "icon_trash_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon_trash_svg__a"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    mask: "url(#icon_trash_svg__b)",
    d: "M12 26h2V11h-2zM18 26h2V11h-2z"
  })));
}

export default SvgIconTrash;